import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../components/Forms/PresetsTextField'

const OverwhelmPlan = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12}>
      <PresetsTextField
        label="Operational Overwhelm Plan"
        multiline
        minRows={2}
        value={medPlan?.overwhelmPlan}
        fullWidth
        suggestionPath="medPlan.overwhelmPlan"
        suggestionLabel="Overwhelm plans from templates"
        setValue={(newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            overwhelmPlan: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        InputLabelProps={{
          shrink: !!medPlan?.overwhelmPlan,
        }}
      />
    </Grid>
  )
}

export default React.memo(OverwhelmPlan)
